import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutSmsQuickInfo extends Layout {
    btnMarkAllRead: Button;
    buttonViewAll: Button;
    horizontalspacer4: HorizontalSpacer;
    labelMessageCount: Label;
    labelMessageCountText: Label;
    panelHeader: Panel;
    sourceCarrierDriverMessage: DataSource;
    sourceCurrentUserPowerbroker: DataSource;
    tableSmsQuickInfo: Table;
}
